module.exports = __webpack_public_path__ + "static/media/custom-voicing-icon.26bf7556.svg";